import { render, staticRenderFns } from "./uniform.vue?vue&type=template&id=dabde9c6&scoped=true"
import script from "./uniform.vue?vue&type=script&lang=js"
export * from "./uniform.vue?vue&type=script&lang=js"
import style0 from "./uniform.vue?vue&type=style&index=0&id=dabde9c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabde9c6",
  null
  
)

export default component.exports